module.exports = __webpack_public_path__ + "static/media/ellie.b04f109f.jpg";